import React from 'react';
import $ from "jquery";

var GraphListView = React.createClass({
  getInitialState: function() {
    var state = {
      
    };
    return state;
  },

  handleLineClick: function(e, i){
    if (this.props.objectPageKey && this.props.data.ids[i]) {
      if (e.button === 0) {
        $(document).trigger("changePage", [this.props.objectPageKey, {id: this.props.data.ids[i]}]);
      } else if (e.button === 1) {
        $(document).trigger("openPage", [this.props.objectPageKey, {id: this.props.data.ids[i]}]);
      }
    }
  },


  render: function() {
    let lines = this.props.data.labels.map(function(labelData, i){
      let valueData = this.props.data.datasets[0].data[i];
      let value = null;
      if (Array.isArray(valueData)) {
        value = valueData.reverse().map(function(valueDatum, i){
          return <span key={i}>{valueDatum}</span>
        });
      } else {
        value = <span>{valueData}</span>
      }
      let label = <span>{labelData}</span>;
      if (this.props.objectPageKey && this.props.data.ids[i]) {
        label = 
          <a onMouseDown={function(e){this.handleLineClick(e,i)}.bind(this)}>
            {label}
          </a>
      }
      return (
        <div key={i} className="graphListItem">
          <div className="valueLabel">
            {label}
          </div>
          <div className="valueLabel">
            {value}
          </div>
        </div>
      );
    }.bind(this));
    return (
      <div className="graphListView">
        <h4>{this.props.options.title.text}</h4>
        {lines}
      </div>
    )
  },
});

export default GraphListView;



// WEBPACK FOOTER //
// ./src/GraphListView.js